export const PATIENT_CREATE_REQUEST = 'PATIENT_CREATE_REQUEST'
export const PATIENT_CREATE_SUCCESS = 'PATIENT_CREATE_SUCCESS'
export const PATIENT_CREATE_FAIL = 'PATIENT_CREATE_FAIL'
export const PATIENT_CREATE_RESET = 'PATIENT_CREATE_RESET'


export const LIST_PATIENT_REQUEST = 'LIST_PATIENT_REQUEST'
export const LIST_PATIENT_SUCCESS = 'LIST_PATIENT_SUCCESS'
export const LIST_PATIENT_FAIL = 'LIST_PATIENT_FAIL'
export const LIST_PATIENT_RESET = 'LIST_PATIENT_RESET'

export const PATIENT_DELETE_REQUEST = 'PATIENT_DELETE_REQUEST'
export const PATIENT_DELETE_SUCCESS = 'PATIENT_DELETE_SUCCESS '
export const PATIENT_DELETE_FAIL = 'PATIENT_DELETE_FAIL'


export const LIST_STATUS_ENUMS_REQUEST = 'LIST_STATUS_ENUMS_REQUEST'
export const LIST_STATUS_ENUMS_SUCCESS = 'LIST_STATUS_ENUMS_SUCCESS'
export const LIST_STATUS_ENUMS_FAIL = 'LIST_STATUS_ENUMS_FAIL'
export const LIST_STATUS_ENUMS_RESET = 'LIST_STATUS_ENUMS_RESET'


export const LIST_GENDER_ENUMS_REQUEST = 'LIST_GENDER_ENUMS_REQUEST'
export const LIST_GENDER_ENUMS_SUCCESS = 'LIST_GENDER_ENUMS_SUCCESS'
export const LIST_GENDER_ENUMS_FAIL = 'LIST_GENDER_ENUMS_FAIL'
export const LIST_GENDER_ENUMS_RESET = 'LIST_GENDER_ENUMS_RESET'


export const LIST_TYPES_ENUMS_REQUEST = 'LIST_TYPES_ENUMS_REQUEST'
export const LIST_TYPES_ENUMS_SUCCESS = 'LIST_TYPES_ENUMS_SUCCESS'
export const LIST_TYPES_ENUMS_FAIL = 'LIST_TYPES_ENUMS_FAIL'
export const LIST_TYPES_ENUMS_RESET = 'LIST_TYPES_ENUMS_RESET'


export const UPDATE_PATIENT_REQUEST = 'UPDATE_PATIENT_REQUEST'
export const UPDATE_PATIENT_SUCCESS = 'UPDATE_PATIENT_SUCCESS'
export const UPDATE_PATIENT_FAIL = 'UPDATE_PATIENT_FAIL'
export const UPDATE_PATIENT_RESET = 'UPDATE_PATIENT_RESET'


export const PATIENT_DETAILS_REQUEST = 'PATIENT_DETAILS_REQUEST'
export const PATIENT_DETAILS_SUCCESS = 'PATIENT_DETAILS_SUCCESS'
export const PATIENT_DETAILS_FAIL = 'PATIENT_DETAILS_FAIL'


export const PATIENT_DETAILS_USER_REQUEST = 'PATIENT_DETAILS_USER_REQUEST'
export const PATIENT_DETAILS_USER_SUCCESS = 'PATIENT_DETAILS_USER_SUCCESS'
export const PATIENT_DETAILS_USER_FAIL = 'PATIENT_DETAILS_USER_FAIL'